import { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Formik } from "formik";
import { Slide, ToastContainer, toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { DefaultLayout } from "../../../../../../layouts/Default";
import { TopNavigation } from "../../../../../../themes/Default/components/TopNavigation";
import { Button, ButtonBack } from "../../../../../../themes/Default/components/TopNavigation/components/Button";
import { Tabs } from "../../../../../../themes/Default/components/Tabs";
import { Main } from "../../../../../../themes/Default/components/Main";
import { Breadcrumps } from "../../../../../../themes/Default/components/Breadcrumps";
import { Link } from "../../../../../../themes/Default/components/Breadcrumps/components/Link";
import { Form } from "../../../../../../themes/Default/components/Form";
import { Row } from "../../../../../../themes/Default/components/Form/components/Row";
import { Field } from "../../../../../../themes/Default/components/Form/components/Row/components/Field";
import { Input } from "../../../../../../themes/Default/components/Form/components/Input";
import { settingsCallManagement } from "../../../../../../hooks/api/SettingsCallManagement";

const EditMethodOfContact = () => {
    const { t } = useTranslation("common");
    const formRef = useRef(null);
    const navigate = useNavigate();
    const { methodOfContactId } = useParams();
    const [formErrors, setFormErrors] = useState([]);
    const { useUpdateMethodOfContactMutation, useViewMethodOfContactMutation} = settingsCallManagement;
    const [updateMethodOfContact] = useUpdateMethodOfContactMutation();
    const [viewMethodOfContact] = useViewMethodOfContactMutation();

    const tabs = [
        { title: t('calls.appointment'), onClick: () => gotoAppointmentTab() },
        { title: t("calls.courseType"), onClick: () => gotoCourseTypeTab() },
        { title: t("calls.methodOfContact"), isActive: true },
        { title: t("calls.salesChannel"), onClick: () => gotoSalesChannelTab() },
        { title: t("calls.studentStatus"), onClick: () => gotoStudentStatusTab() },
        { title: t("calls.status"), onClick: () => gotoStatusTab() },
        { title: t("calls.offerSent"), onClick: () => gotoOfferSentTab() },
    ];

    const gotoOfferSentTab = () => {
        navigate("/settings/calls/offer-sent");
    };

    const gotoAppointmentTab = () => {
        navigate("/settings/calls/appointments");
    };

    const gotoCourseTypeTab = () => {
        navigate("/settings/calls/course-type");
    };

    const gotoSalesChannelTab = () => {
        navigate("/settings/calls/sales-channel");
    };

    const gotoStudentStatusTab = () => {
        navigate("/settings/calls/student-status");
    };

    const gotoStatusTab = () => {
        navigate("/settings/calls/status");
    };

    const onSave = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    const onSaved = (values) => {
        const body = {...values};
        updateMethodOfContact({body, methodOfContactId}).then((result) => {
            if (result?.error) {
                setFormErrors(result?.error?.data?.error?.violations);
                toast.error(result.error.data.error.responseMessage);
            } else {
                navigate("/settings/calls/method-of-contact");
                toast.info(result?.data?.info?.responseMessage);
            }
        });
    };

    useEffect(() => {
        viewMethodOfContact(methodOfContactId).then((result) => {
            formRef.current.setValues(result?.data);
            console.log(result?.data);
        });

    }, []);

    return (
        <DefaultLayout>
            
            <TopNavigation>
                <ButtonBack to="/settings/calls/method-of-contact" />
                <Button title={t('save')} icon="fa-regular fa-floppy-disk" onClick={onSave}></Button>
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
                <Breadcrumps>
                    <Link title={t("settings.title")} icon="fa-gear" />
                    <Link title={t("calls.title")} />
                    <Link title={t("calls.methodOfContact")} />
                    <Link title={t("calls.editMethodOfContact")} isActive={true} />
                </Breadcrumps>
                <Formik
                    innerRef={formRef}
                    initialValues={{ 
                        name: ""
                    }}
                    onSubmit={onSaved}
                >
                    {({ values, handleChange }) => (
                        <Form>
                        <Row>
                            <Field>
                                <Input
                                    name="name"
                                    label={t("languages.name")}
                                    required={true}
                                    value={values.name}
                                    onChange={handleChange}
                                    error={formErrors?.name}
                                />
                            </Field>
                        </Row>
                    </Form>
                    )}
                </Formik>
            </Main>
        </DefaultLayout>
    );
};

export default EditMethodOfContact;